import React from 'react'
import { useExercise } from '../ExerciseProvider'
import { useTranslation } from '~/hooks/useTranslation'

const VisionStatementSummary = () => {
  const { getResponse, formattedExerciseName } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pages = t('pages')

  return (
    <div>
      {Object.keys(pages).map((page, index) => {
        if (index !== 5) {
          return (
            <div key={'summary' + index}>
              {pages[page].questions.map((label, idx) => (
                <>
                  <h4
                    className="subtitle mb-6 text-center font-roboto text-base font-normal"
                    key={label.slug + idx}
                  >
                    {label.question}
                  </h4>
                  <p className="!mb-6 text-center font-roboto text-base font-normal">
                    <em>{getResponse(index, label.slug)}</em>
                  </p>
                </>
              ))}
            </div>
          )
        } else {
          return (
            <>
              <h4 className="subtitle mb-6 text-center font-roboto text-base font-normal">
                {t('vision_statement')}:
              </h4>
              <p className="!mb-6 text-center font-roboto text-base font-normal">
                <em>{getResponse(5, 'page_six_textbox')}</em>
              </p>
              <p className="font-roboto text-base font-normal">
                {t('conclusion_next_steps')}
              </p>
            </>
          )
        }
      })}
    </div>
  )
}

export default VisionStatementSummary
